"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MONTHS = [undefined, 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const WORKDAYS = {
    GB: require('../config/workdays/GB.json')
};
const PAST_OFFSET = { day: { D: -1 }, week: { D: -7 }, month: { M: -1 }, quarter: { M: -3 }, year: { Y: -1 } };
const NEXT_OFFSET = { day: { D: 1 }, week: { D: 7 }, month: { M: 1 }, quarter: { M: 3 }, year: { Y: 1 } };
const TIMEZONE_OFFSET = { "ACDT": 37800000, "ACST": 34200000, "ACT": -18000000, "ACWST": 31500000, "ADT": -10800000, "AEDT": 39600000, "AEST": 36000000, "AET": 36000000, "AFT": 16200000, "AKDT": -28800000, "AKST": -32400000, "ALMT": 21600000, "AMST": -10800000, "AMT": -14400000, "ANAT": 43200000, "AQTT": 18000000, "ART": -10800000, "AST": -14400000, "AWST": 28800000, "AZOST": 0, "AZOT": -3600000, "AZT": 14400000, "BNT": 28800000, "BIOT": 21600000, "BIT": -43200000, "BOT": -14400000, "BRST": -7200000, "BRT": -10800000, "BST": 3600000, "BTT": 21600000, "CAT": 7200000, "CCT": 23400000, "CDT": -18000000, "CEST": 7200000, "CET": 3600000, "CHADT": 49500000, "CHAST": 45900000, "CHOT": 28800000, "CHOST": 32400000, "CHST": 36000000, "CHUT": 36000000, "CIST": -28800000, "CKT": -36000000, "CLST": -10800000, "CLT": -14400000, "COST": -14400000, "COT": -18000000, "CST": -21600000, "CT": -21600000, "CVT": -3600000, "CWST": 31500000, "CXT": 25200000, "DAVT": 25200000, "DDUT": 36000000, "DFT": 3600000, "EASST": -18000000, "EAST": -21600000, "EAT": 10800000, "ECT": -18000000, "EDT": -14400000, "EEST": 10800000, "EET": 7200000, "EGST": 0, "EGT": -3600000, "EST": -18000000, "ET": -18000000, "FET": 10800000, "FJT": 43200000, "FKST": -10800000, "FKT": -14400000, "FNT": -7200000, "GALT": -21600000, "GAMT": -32400000, "GET": 14400000, "GFT": -10800000, "GILT": 43200000, "GIT": -32400000, "GMT": 0, "GST": 14400000, "GYT": -14400000, "HDT": -32400000, "HAEC": 7200000, "HST": -36000000, "HKT": 28800000, "HMT": 18000000, "HOVST": 28800000, "HOVT": 25200000, "ICT": 25200000, "IDLW": -43200000, "IDT": 10800000, "IOT": 10800000, "IRDT": 16200000, "IRKT": 28800000, "IRST": 12600000, "IST": 19800000, "JST": 32400000, "KALT": 7200000, "KGT": 21600000, "KOST": 39600000, "KRAT": 25200000, "KST": 32400000, "LHST": 37800000, "LINT": 50400000, "MAGT": 43200000, "MART": -30600000, "MAWT": 18000000, "MDT": -21600000, "MET": 3600000, "MEST": 7200000, "MHT": 43200000, "MIST": 39600000, "MIT": -30600000, "MMT": 23400000, "MSK": 10800000, "MST": -25200000, "MUT": 14400000, "MVT": 18000000, "MYT": 28800000, "NCT": 39600000, "NDT": -5400000, "NFT": 39600000, "NOVT": 25200000, "NPT": 20700000, "NST": -9000000, "NT": -9000000, "NUT": -39600000, "NZDT": 46800000, "NZST": 43200000, "OMST": 21600000, "ORAT": 18000000, "PDT": -25200000, "PET": -18000000, "PETT": 43200000, "PGT": 36000000, "PHOT": 46800000, "PHT": 28800000, "PHST": 28800000, "PKT": 18000000, "PMDT": -7200000, "PMST": -10800000, "PONT": 39600000, "PST": -28800000, "PWT": 32400000, "PYST": -10800000, "PYT": -14400000, "RET": 14400000, "ROTT": -10800000, "SAKT": 39600000, "SAMT": 14400000, "SAST": 7200000, "SBT": 39600000, "SCT": 14400000, "SDT": -36000000, "SGT": 28800000, "SLST": 19800000, "SRET": 39600000, "SRT": -10800000, "SST": -39600000, "SYOT": 10800000, "TAHT": -36000000, "THA": 25200000, "TFT": 18000000, "TJT": 18000000, "TKT": 46800000, "TLT": 32400000, "TMT": 18000000, "TRT": 10800000, "TOT": 46800000, "TVT": 43200000, "ULAST": 32400000, "ULAT": 28800000, "UTC": 0, "UYST": -7200000, "UYT": -10800000, "UZT": 18000000, "VET": -14400000, "VLAT": 36000000, "VOLT": 10800000, "VOST": 21600000, "VUT": 39600000, "WAKT": 43200000, "WAST": 7200000, "WAT": 3600000, "WEST": 3600000, "WET": 0, "WIB": 25200000, "WIT": 32400000, "WITA": 28800000, "WGST": -7200000, "WGT": -10800000, "WST": 28800000, "YAKT": 32400000, "YEKT": 18000000 };
class Time {
    time;
    timezone;
    constructor(date, options) {
        if (typeof date === 'string' && /^[a-zA-Z]{3,4} [0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2} [A-Z]{2,5}$/.test(date)) {
            const { datetime, timezone } = date.match(/^[a-zA-Z]{3,4} (?<datetime>[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}) (?<timezone>[A-Z]{2,5})$/)?.groups;
            date = new Date(datetime);
            date.setMilliseconds(date.getMilliseconds() - Time.timezoneOffset('UTC', undefined, date) - (TIMEZONE_OFFSET[timezone] ?? 0));
        }
        this.time = new Date();
        this.timezone = options?.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (typeof date === 'string' && /^[0-9]+$/.test(date)) {
            date = parseInt(date);
        }
        if (date === undefined) {
            date = Time.format(new Date(), 'datetime', options?.timezone);
        }
        if (typeof date === 'string') {
            if (/^[0-9]{4}(-[0-9]{2}){0,2}$/.test(date) || /^[0-9]{4}-[0-9]{2}-[0-9]{2}[ T][0-9]{2}:[0-9]{2}:[0-9]{2}$/.test(date)) {
                this.time = new Date(date + '0000-01-01 00:00:00'.substring(date.length));
            }
            else {
                throw 'Invalid date';
            }
        }
        else if (typeof date === 'number') {
            this.time = new Date(date <= 4000000000 ? date * 1000 : date);
        }
        else if (date instanceof Date) {
            this.time = new Date(date);
        }
        if (options?.timezone && (date === undefined || typeof date === 'number' || date instanceof Date)) {
            this.time.setMilliseconds(this.time.getMilliseconds() + Time.timezoneOffset(options?.timezone, undefined, this.time));
        }
    }
    static normalizeDateString(date = '') {
        if (date.match(/^\s*[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}\s*$/)) {
            return date.replace(/([0-9]{4})-([0-9]{1,2})-([0-9]{1,2})/, (_, y, m, d) => {
                return y + '-' + m.padStart(2, '0') + '-' + d.padStart(2, '0');
            });
        }
        else if (date.match(/^\s*[0-9]{1,2}[/\.\s]+[0-9]{1,2}[/\.\s]+[0-9]{4}\s*$/)) {
            return date.replace(/([0-9]{1,2})[/\.\s]+([0-9]{1,2})[/\.\s]+([0-9]{4})/, (_, d, m, y) => {
                return y + '-' + m.padStart(2, '0') + '-' + d.padStart(2, '0');
            });
        }
        else if (date.match(/^\s*[0-9]{1,2}[\.\s-]+[a-zA-Z]{3}[\.\s-]+[0-9]{4}\s*$/)) {
            return date.replace(/([0-9]{1,2})[\.\s-]+([a-zA-Z]{3})[\.\s-]+([0-9]{4})/, (_, d, m, y) => {
                return y + '-' + MONTHS.findIndex(M => M?.toLowerCase() === m.toLowerCase()).toString().padStart(2, '0') + '-' + d.padStart(2, '0');
            });
        }
    }
    static timezoneOffset(timezone, origin = Intl.DateTimeFormat().resolvedOptions().timeZone, date = new Date()) {
        return new Date(date.toLocaleString('en-GB', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).replace(/([0-9]{2})\/([0-9]{2})\/([0-9]{4})[^0-9]*([0-9]{2}):([0-9]{2}):([0-9]{2})/, '$3-$2-$1 $4:$5:$6').replace(/ 24:/, ' 00:')).getTime()
            - new Date(date.toLocaleString('en-GB', { timeZone: origin, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).replace(/([0-9]{2})\/([0-9]{2})\/([0-9]{4})[^0-9]*([0-9]{2}):([0-9]{2}):([0-9]{2})/, '$3-$2-$1 $4:$5:$6').replace(/ 24:/, ' 00:')).getTime();
    }
    static timestamp(datetime, timezone) {
        let timestamp = Math.round(new Date(datetime).getTime() / 1000), offset = 0, endTime = Time.format(new Date(timestamp * 1000), 'datetime', timezone);
        while (endTime !== datetime) // TODO zlepsit
         {
            offset += endTime > datetime ? -3600 : 3600;
            endTime = Time.format(new Date((timestamp + offset) * 1000), 'datetime', timezone);
        }
        return timestamp + offset;
    }
    static interval(date, format, human = false) {
        let [Y, M, D] = date.split(/[ T]/)[0].split('-');
        // TODO week? weekStart weeekEnd?
        if (format === 'month') {
            return human ? MONTHS[parseInt(M)] + ' ' + Y : Y + '-' + M;
        }
        if (format === 'quarter') {
            return (human ? '' : Y + '-') + 'Q' + (Math.floor((parseInt(M) - 1) / 3) + 1) + (human ? ' ' + Y : '');
        }
        if (format === 'year') {
            return Y;
        }
        return Y + '-' + M + '-' + D;
    }
    interval(format, human = false) {
        return Time.interval(this.format('day'), format, human);
    }
    static *range(start, end, unit, human = false) {
        let current = new Time(start).startOf(unit), until = new Time(end);
        do {
            yield Time.interval(current.format('datetime'), unit, human);
        } while (current.offset(NEXT_OFFSET[unit]) && current.time < until.time);
    }
    static format(date, format, timezone) {
        let day = Intl.DateTimeFormat('en-GB', { dateStyle: 'short', timeZone: timezone }).format(date);
        if (!format.startsWith('human')) {
            day = day.split('/').reverse().join('-');
        }
        return day + (format.endsWith('time') ? ' ' + Intl.DateTimeFormat('en-GB', { timeStyle: format === 'datetime' ? 'medium' : 'short', timeZone: timezone }).format(date) : '');
    }
    format(format, timezone) {
        if ((timezone === undefined || timezone === this.timezone) && ['day', 'datetime', 'humandate', 'humandatetime'].includes(format)) {
            return Time.format(this.time, format);
        }
        let datetime = Time.format(this.time, 'datetime');
        let timestamp = Time.timestamp(datetime, this.timezone);
        if (format === 'timestamp') {
            return timestamp;
        }
        if (format === 'date') {
            return new Date(timestamp * 1000);
        }
        return Time.format(new Date(timestamp * 1000), format, timezone);
    }
    intl(options, locale = 'en-GB') {
        return new Intl.DateTimeFormat(locale, options).format(new Date(this.format('datetime')));
    }
    get date() {
        let date = new Date(this.time);
        date.setMilliseconds(date.getMilliseconds() - Time.timezoneOffset(this?.timezone, undefined, date));
        return date;
    }
    getDay() {
        return this.time.getDay();
    }
    get weekday() {
        return (this.getDay() + 6) % 7;
    }
    startOf(interval) {
        let startTime = this.endOf(interval);
        switch (interval) {
            case 'day': {
                startTime.time.setDate(startTime.time.getDate() - 1);
                break;
            }
            case 'week': {
                startTime.time.setDate(startTime.time.getDate() - 7);
                break;
            }
            case 'month': {
                startTime.time.setMonth(startTime.time.getMonth() - 1);
                break;
            }
            case 'quarter': {
                startTime.time.setMonth(startTime.time.getMonth() - 3);
                break;
            }
            case 'year': {
                startTime.time.setFullYear(startTime.time.getFullYear() - 1);
                break;
            }
        }
        return startTime;
    }
    endOf(interval) {
        let endTime = new Time(this.time, { timezone: this.timezone });
        endTime.time.setHours(0, 0, 0, 0);
        //console.log( 'endOf', endTime.time );
        switch (interval) {
            case 'day': {
                endTime.time.setHours(24);
                break;
            }
            case 'week': {
                endTime.time.setDate(endTime.time.getDate() + 7 - endTime.weekday);
                break;
            }
            case 'month': {
                endTime.time.setMonth(endTime.time.getMonth() + 1, 1);
                break;
            }
            case 'quarter': {
                endTime.time.setMonth(Math.floor(1 + endTime.time.getMonth() / 3) * 3, 1);
                break;
            }
            case 'year': {
                endTime.time.setFullYear(endTime.time.getFullYear() + 1, 0, 1);
                break;
            }
        }
        return endTime;
    }
    lastOf(interval) {
        let last = this.endOf(interval);
        last.time.setMilliseconds(-1);
        //console.log( 'lastOf', last.time, last.format('datetime') );
        return last;
    }
    offset(offset) {
        this.time.setHours(this.time.getHours() + (offset.h ?? 0), this.time.getMinutes() + (offset.m ?? 0), this.time.getSeconds() + (offset.s ?? 0), this.time.getMilliseconds() + (offset.ms ?? 0));
        this.time.setFullYear(this.time.getFullYear() + (offset.Y ?? 0), this.time.getMonth() + (offset.M ?? 0), this.time.getDate() + (offset.D ?? 0));
        return this;
    }
    intervals(interval, count = 1, format = 'date') {
        let end = this.endOf(interval), intervals = [end.format(format)];
        //console.log( 'END', this.format('datetime'), intervals );
        for (let i = 0; i < count; ++i) {
            intervals.push(end.offset(PAST_OFFSET[interval]).format(format));
        }
        return intervals;
    }
    intervals2D(interval, subinterval, format = 'timestamp') {
        //let [ start, end ] = this.intervals( interval, 2, 'datetime' ), intervals = [];
    }
    static days(start, end) {
        return Math.round((end.time.getTime() - start.time.getTime()) / 86400000);
    }
    static workdays(start, end) {
        const startDay = start.getDay(), endDay = (end.getDay() + 6) % 7;
        const startDate = start.format('day'), endDate = end.format('day');
        let days = Time.days(start, end);
        days -= Math.floor(days / 7) * 2
            + (startDay - endDay > 1 ? 2 : 0)
            + (startDay === 0 && endDay !== 6 ? 1 : 0)
            + (endDay === 6 && startDay !== 0 ? 1 : 0);
        days -= WORKDAYS.GB.filter(day => startDate <= day && day < endDate).length;
        return days;
    }
}
exports.default = Time;
